/**
 * SPZ 7001-specific JS
 *
 */
"use strict";

export default class Spz7001 {
  
  /**
   * Constructor
   *
   * @returns
   */
  constructor() {
    this.init();
  }

  init()
  {
    let telcontactNo = document.querySelector('.nav-chek .main__button--mobile').getAttribute("href");
    let contNo       = telcontactNo.slice(telcontactNo.indexOf('('));

    document.querySelector('.nav-menu .nav-chek').insertAdjacentHTML('afterEnd', `<div class="nav-callcta"><a class="top-nav" href="${telcontactNo}">${contNo}</a></div>`);

    document.querySelector('#form-w4').classList.add('s1-clear');
    document.querySelector('.step1_warp .s1_cta').addEventListener('click', function() {
      document.querySelector('#form-w4').classList.remove('s1-clear');
      document.querySelector('.form_wrap').classList.add('s1-hide');
    });
  }
}

const spz_7001 = new Spz7001();